{
  "hero": {
    "title": "{name}'s day",
    "title_unnamed": "Your golfer's day",
    "new_title": "Your golf life starts here",
    "new_body": "Make your golfer. Then the game plays the golf, and you make the choices.",
    "no_server_body": "Your golfer's day shows here once this build can reach the game's server."
  },
  "parts": {
    "since": "Since you were last here",
    "condition": "Your golfer today",
    "next": "Next"
  },
  "fact": {
    "last_round": "Last round: {gross} ({toPar}), {course}",
    "last_round_label": "Last round",
    "last_round_value": "{gross} ({toPar})",
    "no_round": "No rounds yet. Your golfer's first report will show here.",
    "playing_level_label": "Playing level",
    "playing_level_value": "{level}",
    "playing_level_rust": "{level}, with {rust} of rust",
    "energy_label": "Energy",
    "energy_full_at": "Full at {time}",
    "rust_label": "Rust",
    "rust_value": "About {rust} shots. It wears off as your golfer plays."
  },
  "to_par": {
    "even": "level par",
    "over": "{n} over",
    "under": "{n} under"
  },
  "condition_word": {
    "fresh": "Fresh",
    "good": "Good",
    "tired": "Tired",
    "low": "Low"
  },
  "action": {
    "get_ready": "Get ready for the next round",
    "get_ready_detail": "Open Play, where the next round starts",
    "make_golfer": "Make your golfer",
    "open_report": "Open the report",
    "see_golfer": "See your golfer",
    "see_week": "See the week's plan",
    "retry": "Try again"
  },
  "next_line": "A practice round, whenever you are ready.",
  "end": "That's everything for today. Nothing else needs you.",
  "error": "Your golfer's day did not load. Your golfer is safe.",
  "loading": "Loading your golfer's day",
  "wallet": "Wallet",
  "checkin": {
    "title": "Today's check-in",
    "body": "One tap confirms today's training and adds {coins} Coins to your wallet.",
    "button": "Check in",
    "tweak": "Change today's plan first",
    "done": "Checked in. Today's training is confirmed, and {coins} Coins are in your wallet.",
    "done_before": "You've checked in today. Today's training is confirmed.",
    "offline": "Connect to check in.",
    "error": "That didn't work. Try again."
  }
}
